import axios from 'axios';

const http = axios.create({
  baseURL: `${process.env.VUE_APP_API}`,
  headers: {
    "Cache-Control": "no-store",
  }
});

export default http
